module.exports = __webpack_public_path__ + "static/img/12.765f8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/12.png
// module id = pa4M
// module chunks = 5